<template>
  <div class="travelers">
    <content-section
      title="Elenco dei passeggeri"
      description="Verifica che nomi e date di nascita siano corrispondenti a quelli riportati nel documento di identità con cui verrà fatto l'imbarco"
    >
      <template>
        <div class="travelers__wrapper">
          <div
            v-for="(traveler, index) in safe_travelers"
            :key="_uid + index"
            class="travelers__user-info"
          >
            <div class="travelers__user-name">
              <span>Nome e cognome:</span>
              <span class="semibold">{{ traveler_name(traveler) }}</span>
            </div>
            <div 
              v-if="traveler.display_birth_date" 
              class="travelers__user-age"
            >
              <span>Data di nascita:</span>
              <span class="semibold">{{ traveler.display_birth_date }}</span>
            </div>
          </div>
        </div>
      </template>
    </content-section>
  </div>
</template>

<script>
  import { reverse_date } from '@/utilities/commons';
  import { traveler_name } from '@liveflight/utilities';
  import ContentSection from '@liveflight/components/blocks/wrappers/content-section.vue';

  export default {
    name: 'travelers',
    components: {
      'content-section': ContentSection,
    },
    props: {
      travelers: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      safe_travelers() {
        return this.travelers.map((traveler) => ({
          ...traveler, 
          display_birth_date: reverse_date(traveler.dateOfBirth || traveler.birth)
        }))
      }
    },
    methods: {
      traveler_name 
    }
  };
</script>

<style lang="scss">
  .travelers {
    &__wrapper {
      margin-top: -$grid-gutter-20;
      @include media-breakpoint-up(xl) {
        display: grid;
        grid-template-columns: auto auto;
      }
    }

    &__user {
      &-info {
        margin-top: $grid-gutter-width;
      }

      &-name,
      &-age {
        display: flex;
        gap: $grid-gutter-width / 3;
      }
    }
  }
</style>
